import {
  ONE_TRUST_CONSENT_CATEGORY_FOR_HOTJAR,
  ONE_TRUST_CONSENT_CATEGORY_FOR_MIXPANEL,
  ONE_TRUST_CONSENT_GIVEN,
  ONE_TRUST_CONSENT_KEY,
  ONE_TRUST_COOKIE_ALERTBOX_KEY,
  ONE_TRUST_COOKIE_CONSENTS_KEY,
  ONE_TRUST_URI_QUERY_PARAM_KEY
} from 'constants/oneTrust'
import {
  GetHasHotjarConsent,
  GetHasMixPanelConsent,
  GetHaveOneTrustCookiesBeenSet,
  GetOneTrustCookie,
  GetOneTrustTrackingConsentsFromCookie,
  SetOneTrustCookieFromQueryURL
} from './oneTrust.types'

export const getOneTrustConsentsCookie: GetOneTrustCookie = () => (
  document.cookie
    .split(';')
    .map(cookieInfo => cookieInfo.trim())
    .find(cookieInfo => cookieInfo.startsWith(ONE_TRUST_COOKIE_CONSENTS_KEY))
)

export const getOneTrustAlertBoxCookie: GetOneTrustCookie = () => (
  document.cookie
    .split(';')
    .map(cookieInfo => cookieInfo.trim())
    .find(cookieInfo => cookieInfo.startsWith(ONE_TRUST_COOKIE_ALERTBOX_KEY))
)

export const getHaveOneTrustCookiesBeenSet: GetHaveOneTrustCookiesBeenSet = () => (
  getOneTrustAlertBoxCookie() !== undefined &&
  getOneTrustConsentsCookie() !== undefined
)

export const getOneTrustTrackingConsentsFromCookie: GetOneTrustTrackingConsentsFromCookie = () => {
  const encodedConsents = getOneTrustConsentsCookie()
    ?.replace(`${ONE_TRUST_COOKIE_CONSENTS_KEY}=`, '')
    ?.split('&')
    ?.find(info => info.startsWith(ONE_TRUST_CONSENT_KEY))

  return encodedConsents === undefined
    ? undefined
    : decodeURIComponent(encodedConsents)
      .replace(`${ONE_TRUST_CONSENT_KEY}=`, '')
      .split(',')
      .reduce((acc, curr) => {
        const [key, val] = curr.split(':')

        acc[key] = val

        return acc
      }, {})
}

export const getHasMixPanelConsent: GetHasMixPanelConsent = consents => {
  if (consents === undefined) { return true }

  return (
    getOneTrustAlertBoxCookie() !== undefined &&
    consents?.[ONE_TRUST_CONSENT_CATEGORY_FOR_MIXPANEL] === ONE_TRUST_CONSENT_GIVEN
  )
}

export const getHasHotjarConsent: GetHasHotjarConsent = consents => {
  if (consents === undefined) { return true }

  return (
    getOneTrustAlertBoxCookie() !== undefined &&
    consents?.[ONE_TRUST_CONSENT_CATEGORY_FOR_HOTJAR] === ONE_TRUST_CONSENT_GIVEN
  )
}

export const setOneTrustCookieFromQueryURL: SetOneTrustCookieFromQueryURL = () => {
  const searchParams = window.location.href.split('?')[1] ?? ''
  const consentString = new URLSearchParams(searchParams).get(ONE_TRUST_URI_QUERY_PARAM_KEY)

  if (consentString !== null) {
    document.cookie = ONE_TRUST_COOKIE_ALERTBOX_KEY + '=' + new Date().toISOString() // Set Cookie to disable banner display
    const expiresDate = new Date()
    expiresDate.setFullYear(expiresDate.getFullYear() + 1)
    const expires = expiresDate.toISOString()
    const datestamp = new Date().toString().replace(/ /g, '+').replace(/:/g, '%3A')
    document.cookie = `${ONE_TRUST_COOKIE_CONSENTS_KEY}=datestamp=${datestamp}&version=6.0.0&interactionCount=0&isIABGlobal=false&landingPath=NotLandingPage&${ONE_TRUST_CONSENT_KEY}=${encodeURIComponent(consentString)}&hosts=&legInt=; expires=${expires}`
  }
}
